module.exports = __webpack_public_path__ + "img/gemini_ventures_logo.svg";